<!-- BEGIN #header -->
<div id="header" class="app-header" [attr.data-bs-theme]="this.appSettings.appHeaderInverse ? 'dark' : ''">
    <!-- BEGIN navbar-header -->
    <div class="navbar-header">
        <button type="button" class="navbar-mobile-toggler" *ngIf="this.appSidebarTwo"
            (click)="toggleAppSidebarEndMobile()">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <a href="/" class="ms-3"> <img src="/assets/kisna/kisna-logo.svg" name="kinsa-log" /> </a>
        <button type="button" class="navbar-mobile-toggler" (click)="toggleAppTopMenuMobile()"
            *ngIf="this.appSettings.appTopMenu && !this.appSettings.appSidebarNone">
            <span class="fa-stack fa-lg text-inverse">
                <i class="far fa-square fa-stack-2x"></i>
                <i class="fa fa-cog fa-stack-1x"></i>
            </span>
        </button>
        <button type="button" class="navbar-mobile-toggler" (click)="toggleAppHeaderMegaMenuMobile()"
            *ngIf="this.appSettings.appHeaderMegaMenu">
            <span class="fa-stack fa-lg text-inverse">
                <i class="far fa-square fa-stack-2x"></i>
                <i class="fa fa-cog fa-stack-1x"></i>
            </span>
        </button>
        <button type="button" class="navbar-mobile-toggler" (click)="toggleAppSidebarMobile()"
            *ngIf="!this.appSettings.appSidebarNone">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <button type="button" class="navbar-mobile-toggler" (click)="toggleAppTopMenuMobile()"
            *ngIf="this.appSettings.appTopMenu && this.appSettings.appSidebarNone">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
    </div>
    <!-- END navbar-header -->
    <!-- BEGIN mega-menu -->
    <div class="collapse d-md-block me-auto" *ngIf="this.appSettings.appHeaderMegaMenu"
        [ngClass]="{ 'd-block': (this.appSettings.appHeaderMegaMenu && this.appSettings.appHeaderMegaMenuMobileToggled) }">
        <div class="navbar-nav">
            <div class="navbar-item dropdown dropdown-lg">
                <a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center"
                    data-bs-toggle="dropdown">
                    <i class="fa fa-th-large fa-fw me-1"></i>
                    <span class="d-lg-inline d-md-none">Mega</span>
                    <b class="caret ms-1"></b>
                </a>
                <div class="dropdown-menu dropdown-menu-lg">
                    Content here
                </div>
            </div>
            <div class="navbar-item">
                <a href="javascript:;" class="navbar-link d-flex align-items-center">
                    <i class="fa fa-gem fa-fw me-1"></i>
                    <span class="d-lg-inline d-md-none">Client</span>
                </a>
            </div>
            <div class="navbar-item dropdown">
                <a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center"
                    data-bs-toggle="dropdown">
                    <i class="fa fa-database fa-fw me-1"></i>
                    <span class="d-lg-inline d-md-none">New</span>
                    <b class="caret ms-1"></b>
                </a>
                <div class="dropdown-menu">
                    <a href="javascript:;" class="dropdown-item">Action</a>
                    <a href="javascript:;" class="dropdown-item">Another action</a>
                    <a href="javascript:;" class="dropdown-item">Something else here</a>
                    <div class="dropdown-divider"></div>
                    <a href="javascript:;" class="dropdown-item">Separated link</a>
                    <div class="dropdown-divider"></div>
                    <a href="javascript:;" class="dropdown-item">One more separated link</a>
                </div>
            </div>
        </div>
    </div>
    <div class="navbar-nav">
        <div class="navbar-item navbar-form">
            <div class="form-group">
                <input type="search" name="search" class="form-control" placeholder="Search..." autocomplete="off"
                    (keyup.enter)="onGlobalSearch($event)" />
            </div>
        </div>

        <div class="navbar-item navbar-form">
            <div class="form-group">
                <button class="btn btn-outline-primary" (click)="onPullData()">Pull Invoices</button>
            </div>
        </div>

        <!-- <div class="navbar-item dropdown">
            <a href="javascript:;" data-bs-toggle="dropdown" class="navbar-link dropdown-toggle position-relative"
                style="margin-top: 7px;">
                <i class="fa-regular fa-bell fs-5"></i>
                <span class="badge bg-danger" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
            </a>

            <div class="dropdown-menu media-list dropdown-menu-end"
                style="min-width: 320px; max-height: 460px; overflow-y: auto;">

                <div class="dropdown-header d-flex justify-content-between align-items-center">
                    <span>NOTIFICATIONS ({{ notifications.length }})</span>
                    <a href="javascript:;" class="text-muted fs-10px" (click)="clearNotifications()">Clear all</a>
                </div>

                <div *ngIf="notifications.length === 0" class="dropdown-item text-muted text-center py-3">
                    <i class="fa-regular fa-bell-slash me-1"></i> No notifications
                </div>

                <a href="javascript:;" class="dropdown-item media"
                    *ngFor="let notif of (showAll ? notifications : notifications.slice(0, 5))"
                    [class.bg-light]="!notif.isRead" (click)="onNotificationClick(notif, $event)">

                    <div class="media-left">
                        <i class="fa media-object" [ngClass]="{
							'fa-info-circle bg-primary':          notif.type === 'info',
							'fa-check-circle bg-success':         notif.type === 'success',
							'fa-exclamation-triangle bg-warning': notif.type === 'warning',
							'fa-times-circle bg-danger':          notif.type === 'error',
							'fa-bell bg-gray-500':                !notif.type
                		}">
                        </i>
                    </div>
                    <div class="media-body">
                        <h6 class="media-heading mb-0">{{ notif.title }}</h6>
                        <p class="mb-0 text-muted fs-12px">{{ notif.message }}</p>
                        <div class="text-muted fs-10px">{{ notif.timestamp || notif.createdOn | date: 'short' }}</div>
                    </div>
                </a>

                <div class="dropdown-footer text-center" *ngIf="notifications.length > 5">
                    <a href="javascript:;" class="text-decoration-none" (click)="showAll = !showAll">
                        {{ showAll ? 'Show less' : 'View all (' + notifications.length + ')' }}
                    </a>
                </div>

            </div>
        </div> -->

        <div class="navbar-item dropdown" *ngIf="this.appSettings.appHeaderLanguageBar">
            <a href="javascript:;" class="navbar-link dropdown-toggle" data-bs-toggle="dropdown">
                <span class="fi fi-us" title="us"></span>
                <span class="d-none d-sm-inline ms-1">EN</span> <b class="caret"></b>
            </a>
            <div class="dropdown-menu">
                <a href="javascript:;" class="dropdown-item"><span class="fi fi-us me-2" title="us"></span> English</a>
                <a href="javascript:;" class="dropdown-item"><span class="fi fi-cn me-2" title="cn"></span> Chinese</a>
                <a href="javascript:;" class="dropdown-item"><span class="fi fi-jp me-2" title="jp"></span> Japanese</a>
                <a href="javascript:;" class="dropdown-item"><span class="fi fi-be me-2" title="be"></span> Belgium</a>
                <div class="dropdown-divider"></div>
                <a href="javascript:;" class="dropdown-item text-center">more options</a>
            </div>
        </div>

        <button type="button" class="navbar-link position-relative notification-trigger"
            (click)="toggleNotificationPanel()" aria-label="Open notifications"
            style="background: transparent; border: 0; padding: 0; margin-top: 7px; display: inline-flex; align-items: center; justify-content: center;">
            <i class="fa-regular fa-bell fs-5"></i>
            <span class="badge bg-danger position-absolute top-0 start-100 translate-middle" *ngIf="unreadCount > 0">{{
                unreadCount }}</span>
        </button>

        <div class="navbar-item navbar-user dropdown">
            <a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center "
                data-bs-toggle="dropdown">
                <!-- 👤 Blue user icon instead of username -->
                <img src="/assets/kisna/profileIcon.png" alt="User" class="rounded-none me-1"
                    style="width: 32px; height: 32px; border-radius: 0; ">
            </a>

            <div class="dropdown-menu dropdown-menu-end me-1 shadow-sm rounded-3">
                <a href="javascript:;" class="dropdown-item" (click)="goToProfile()">
                    <i class="fa fa-user-edit me-2 text-secondary"></i> Edit Profile
                </a>
                <div class="dropdown-divider"></div>
                <a href="javascript:;" class="dropdown-item text-danger" (click)="logoutUser()">
                    <i class="fa fa-sign-out-alt me-2"></i> Log Out
                </a>
            </div>
        </div>

        <div class="navbar-divider d-none d-md-block" *ngIf="this.appSidebarTwo"></div>
        <div class="navbar-item d-none d-md-block" *ngIf="this.appSidebarTwo">
            <a href="javascript:;" (click)="toggleAppSidebarEnd()" class="navbar-link icon">
                <i class="fa fa-th"></i>
            </a>
        </div>
    </div>
    <!-- END nav -->
</div>
<!-- END #header -->